import type * as Types from '../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CurrentUserLicenseStatusQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentUserLicenseStatusQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', licenseStatus?: Types.UserLicenseStatus | null } | null };


export const CurrentUserLicenseStatusDocument = gql`
    query CurrentUserLicenseStatus {
  currentUser {
    licenseStatus
  }
}
    `;

/**
 * __useCurrentUserLicenseStatusQuery__
 *
 * To run a query within a React component, call `useCurrentUserLicenseStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserLicenseStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserLicenseStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserLicenseStatusQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserLicenseStatusQuery, CurrentUserLicenseStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserLicenseStatusQuery, CurrentUserLicenseStatusQueryVariables>(CurrentUserLicenseStatusDocument, options);
      }
export function useCurrentUserLicenseStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserLicenseStatusQuery, CurrentUserLicenseStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserLicenseStatusQuery, CurrentUserLicenseStatusQueryVariables>(CurrentUserLicenseStatusDocument, options);
        }
// @ts-ignore
export function useCurrentUserLicenseStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserLicenseStatusQuery, CurrentUserLicenseStatusQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentUserLicenseStatusQuery, CurrentUserLicenseStatusQueryVariables>;
export function useCurrentUserLicenseStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserLicenseStatusQuery, CurrentUserLicenseStatusQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentUserLicenseStatusQuery | undefined, CurrentUserLicenseStatusQueryVariables>;
export function useCurrentUserLicenseStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserLicenseStatusQuery, CurrentUserLicenseStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserLicenseStatusQuery, CurrentUserLicenseStatusQueryVariables>(CurrentUserLicenseStatusDocument, options);
        }
export type CurrentUserLicenseStatusQueryHookResult = ReturnType<typeof useCurrentUserLicenseStatusQuery>;
export type CurrentUserLicenseStatusLazyQueryHookResult = ReturnType<typeof useCurrentUserLicenseStatusLazyQuery>;
export type CurrentUserLicenseStatusSuspenseQueryHookResult = ReturnType<typeof useCurrentUserLicenseStatusSuspenseQuery>;
export type CurrentUserLicenseStatusQueryResult = Apollo.QueryResult<CurrentUserLicenseStatusQuery, CurrentUserLicenseStatusQueryVariables>;